import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { QrCode, MessageSquare, Users, ShieldCheck } from "lucide-react";

export default function Landing() {
  return (
    <div className="min-h-screen bg-zinc-50">
      <nav className="max-w-6xl mx-auto flex items-center justify-between px-6 py-5">
        <div className="flex items-center gap-2.5">
          <img src="/assets/jagaomzet-logo.svg" alt="JagaOmzet" className="w-9 h-9 rounded-xl" />
          <div className="leading-tight">
            <span className="font-extrabold text-lg tracking-tight block">JagaOmzet</span>
            <span className="text-[10px] text-zinc-400 font-medium hidden sm:block">Pembeli Balik, Omzet Naik.</span>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <Link to="/f/kedai-kopi-abc" className="text-sm text-zinc-700 hover:text-emerald-700" data-testid="demo-customer-link">
            Lihat Demo Pelanggan
          </Link>
          <Link to="/login">
            <Button className="bg-emerald-600 hover:bg-emerald-700" data-testid="landing-login-button">Masuk Admin</Button>
          </Link>
        </div>
      </nav>

      <section className="max-w-6xl mx-auto px-6 pt-10 pb-20 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-800 mb-5">
            MVP — Untuk UMKM Indonesia
          </div>
          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight leading-[1.05]">
            Kumpulkan feedback pelanggan<br />lewat <span className="text-emerald-600">satu QR code</span>.
          </h1>
          <p className="mt-5 text-zinc-600 text-base sm:text-lg max-w-xl leading-relaxed">
            JagaOmzet membantu bisnis lokal memahami kepuasan pelanggan, menangani komplain lebih cepat, dan membangun database pelanggan — tanpa aplikasi tambahan.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/login">
              <Button size="lg" className="bg-emerald-600 hover:bg-emerald-700" data-testid="hero-start-button">Mulai Sekarang</Button>
            </Link>
            <Link to="/f/kedai-kopi-abc">
              <Button size="lg" variant="outline" data-testid="hero-demo-button">Coba Demo Pelanggan</Button>
            </Link>
          </div>
        </div>
        <div className="relative">
          <div className="absolute -inset-6 bg-emerald-100/60 blur-3xl rounded-full" />
          <img src="https://images.pexels.com/photos/1855214/pexels-photo-1855214.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Kafe" className="relative rounded-3xl shadow-xl border border-zinc-200 object-cover w-full h-[420px]" />
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 pb-24 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { icon: QrCode, title: "QR Code Outlet", desc: "Cetak QR unik untuk setiap outlet dan pajang di meja." },
          { icon: MessageSquare, title: "3 Tingkat Kepuasan", desc: "PUAS, BIASA SAJA, atau KURANG PUAS — semua tercatat." },
          { icon: Users, title: "Database Pelanggan", desc: "Kumpulkan nama & nomor WhatsApp otomatis." },
          { icon: ShieldCheck, title: "Kelola Komplain", desc: "Ubah status Baru → Diproses → Selesai." },
        ].map(({ icon: Icon, title, desc }) => (
          <div key={title} className="bg-white border border-zinc-200 rounded-2xl p-5 hover:shadow-md transition-shadow">
            <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-700 grid place-items-center mb-3">
              <Icon size={20} />
            </div>
            <div className="font-semibold text-zinc-900">{title}</div>
            <div className="text-sm text-zinc-500 mt-1 leading-relaxed">{desc}</div>
          </div>
        ))}
      </section>
    </div>
  );
}
